module.exports = __webpack_public_path__ + "media/images/players/MCDOWELL_GRAEME-7a876e963b945d790968705405c6f9cf.png";